
import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";
import "./index.css";
import { Breadcrumb, Layout, Menu, Typography } from "antd";
import { Space, Table, Tag, Button } from "antd";
import { Link, Route, Routes } from "react-router-dom";
import PageWrapper from "../../helpers/PageWrapper";
import streamService from '../../../services/streamService';
import TokenService from "../../../services/token.service";
import authAxios from "../../../services/api";

const TeachersPage = () => {
  const [users, setUsers] = useState([]);
  const [teacherId, setTeacherId] = useState();

  useEffect(() => {
    authAxios.get(`http://85.159.27.198:8080/abitur/api/auth/get_by_userid/${TokenService.getLocalUserId()}`, {
      headers: {
        'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
      }
    }).then((response) => {
      authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/teacher/${response.data.id}/streams`, {
        headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
        }
      }).then((response) => {
        console.log(response.data)
        setUsers(response.data)
      });
    });
  }, [])


  return (
    <PageWrapper>
      <Typography.Title level={1}>Список групп</Typography.Title>


      <Table columns={
        [
          {
            title: "Дисциплина",
            dataIndex: "discipline",
            key: "discipline",

          },
          {
            title: "Поток",
            dataIndex: "stream",
            key: "stream",

          },
          {
            title: "Группа",
            dataIndex: "group",
            key: "group",
          },
          {
            title: "Оценки",
            key: "teacher",
            dataIndex: "grades",
            render: (_, record) => (
              <Space size="middle">
                <Link to={`/assessments-page/teacher-id/${record.grades.id}/stream-id/${record.key}`}>Оценить</Link>
              </Space>
            ),

          },
          {
            title: "Action",
            key: "action",
            render: (_, record) => (
              <Space size="middle">
                <Link to={`/lesson-plan-page/teacherId/${record.grades.id}/stream-id/${record.key}`}>Уроки</Link>
              </Space>
            ),
          },

        ]}

        dataSource={
          users.map(user => ({
            key: user.id,
            discipline: user.discipline.nameRu + '/' + user.discipline.name,
            stream:user.name,
            group: user.group.name,
            grades: user.teacher
          }))
        } />

    </PageWrapper>
  )


}
export default TeachersPage
